import React from "react";
import { CustomTable } from "../../../Shared";

export function ListNotifications(props) {
  const {
    notifications = [],
    loading = false,
    error = null,
    pagination = {},
    currentPage = 1,
    setCurrentPage,
    onItemsPerPageChange,
    tableConfig,
    onReload,
  } = props;

  if (error) {
    return (
      <p style={{ color: "red", textAlign: "center", margin: "1rem 0" }}>
        {error}
      </p>
    );
  }

  return (
    <div className="admin-notifications__list">
      <CustomTable
        tableConfig={tableConfig}
        data={notifications}
        loading={loading}
        pagination={pagination}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        onReload={onReload}
        onItemsPerPageChange={onItemsPerPageChange}
      />
    </div>
  );
}
